import React from 'react'
import { Box, Typography } from "@mui/material";

interface editShowActionProps {
    actionValue?: any;
    action?: string;
    actionIndex?: number;
    result?: any;
    projectStatus?: string;
}

const EditContentAction = ({ actionValue }: editShowActionProps) => {
    return (
        <>
            {actionValue && actionValue?.map((action: any, index: number) => (
                <div key={index} style={{ display: 'flex', marginBottom: '10px', flexDirection: 'column' }}>
                    {/* <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>{action?.config_details?.transcribe} </Typography> */}
                    {action ? (
                        <Box>
                        <Typography sx={{ marginLeft: '0px' }}>
                            <strong>Original Value :</strong> {action?.config_details?.default_value || 'Not available'}
                        </Typography>
                        <Typography sx={{ marginLeft: '0px' }}>
                            <strong>Edited Value :</strong> {action?.transcribe || "Not available"}<br/>
                        </Typography>
                        {!!action?.change  && !!action?.similarity &&
                        <Box display="flex" justifyContent="flex-end">
                        <Typography>
                            <strong>AI Detection Score:</strong> {action?.aiContent ? `${action.aiContent}%` : "Not available"} |{" "}
                            <strong>Change:</strong> {action?.change ? `${action.change}%` : "Not available"} |{" "}
                            <strong>Similarity:</strong> {action?.similarity ? `${action.similarity}%` : "Not available"}
                        </Typography>
                        </Box>
                        }
                        </Box>
                    ) : (
                        <Typography sx={{ marginLeft: '0px', color: 'gray' }}>
                            No Transcribe data available.
                        </Typography>
                    )}
                </div>
            ))}
        </>
    )
}

export default EditContentAction